import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'

import { Col, Message, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import CenterAddBankAccountForm from './CenterAddBankAccountForm'
import CenterAddBankAccountView from './CenterAddBankAccountView'
import {
  getCreateProjectVender,
  getRefreshProjectVender,
  getUpdateProjectVender,
  saveBankAccount,
} from '../../redux/actions/contract'
import { startLoading, doneLoading } from '../../utils/loading'
import ButtonPanel from '../ButtonPanel'
import PrintButton from '../../components/buttons/printButton/printButton'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import PreviewButton from '../../components/buttons/previewButton/PreviewButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import notification from '../../utils/notification'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import DownloadButton from '../../components/buttons/downloadButton/downloadButton'
import { downloadDurableArticlesFile } from '../../redux/actions/accountingExpenses'
import { previewFile } from '../../utils/fileUtil'
import { maskIdCard } from '../../utils/dataUtil'

export default function BindRmsAccountWidget(props) {
  const { showCommandButton, isSave } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [showSuccess, setShowSuccess] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [disableBindBtt, setDisableBindBtt] = useState(false)
  // bind

  const dispatch = useDispatch()

  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    const result = formSchema?.rmsRequestFiles?.find((f) => f.fileType === '3')
    if (!result?.file) {
      setDisableBindBtt(true)
    }

    // console.log(result)
  }, [props.schema])

  const handleCallService = async (request, projectVersionId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setShowSuccess(false)
    try {
      let response = await saveBankAccount(request, projectVersionId)
      console.log('response', response)
      if (response.success) {
        setFormSchema(response.model.forms)
        setIsEdit(false)
        setIsError(false)
      }
    } catch (e) {
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setIsError(true)
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    // let request = {
    //   bankCode: data.bankCode || '',
    //   bankName: data.bankName || '',
    //   bankBranch: data.bankBranch,
    //   bankAccountNumber: data.bankAccountNumber,
    //   bankAccountName: data.bankAccountName,
    // }

    // console.log('request', request)
    // handleCallService(request, projectId)
  }

  const handleCreate = async () => {
    console.log('handleCreate')
    startLoading()
    setIsLoading(true)
    try {
      let response = await getCreateProjectVender(projectId)
      console.log('response', response)
      if (response.success) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setFormSchema(response.model.forms)
        isSave(true)
      }
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_FAILED_MSG,
      })
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setIsError(true)
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleRefresh = async () => {
    console.log('handleRefresh')
    startLoading()
    setIsLoading(true)
    try {
      let response = await getRefreshProjectVender(projectId)
      console.log('response', response)
      if (response.success) {
        notification.open('success', {
          title: 'ตรวจสอบข้อมูลสำเร็จ',
        })
        setFormSchema(response.model.forms)
        isSave(true)
      }
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || 'ตรวจสอบข้อมูลไม่สำเร็จ',
      })
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setIsError(true)
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleBind = async () => {
    console.log('handleBind')
    startLoading()
    setIsLoading(true)
    try {
      let response = await getUpdateProjectVender(projectId)
      console.log('response', response)
      if (response.success) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setFormSchema(response.model.forms)
        isSave(true)
      }
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || SAVE_FAILED_MSG,
      })
      if (e?.response?.data) {
        setIsError(e.response.data.errors?.message)
      } else {
        setIsError(true)
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const handlePreViewFiles = async (item) => {
    // alert('handlePreViewFiles')

    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadDurableArticlesFile(item.file)

      previewFile(file, item.fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const getColor = (stype) => {
    let color = '#111111'

    switch (stype) {
      case '1':
      case '2':
        color = '#0d6efdad'
        break

      case '3':
        color = '#2da888'
        break

      case '4':
        color = '#fb8a81'
        break

      default:
        break
    }

    return color
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginTop: 20, marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      <div style={{ padding: 10 }}>
        <Row>
          {formSchema?.venderRmsInfo?.venderStatusLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              {formSchema?.venderRmsInfo?.venderStatusCode ? (
                <>
                  <p>
                    <strong>{`${formSchema?.venderRmsInfo?.venderStatusLabel} : `}</strong>

                    <>
                      <strong
                        style={{
                          color: getColor(formSchema?.venderRmsInfo?.venderStatusCode),
                        }}
                      >
                        {formSchema?.venderRmsInfo?.venderStatus || '-ไม่ระบุ-'}
                      </strong>
                    </>
                  </p>
                </>
              ) : (
                <>
                  <p>
                    <strong>{`${formSchema?.venderRmsInfo?.venderStatusLabel} : `}</strong>

                    <strong>{formSchema?.venderRmsInfo?.venderStatus || '-ไม่ระบุ-'}</strong>
                  </p>
                </>
              )}
            </Col>
          )}

          {formSchema?.venderRmsInfo?.venderAccStatusLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                <strong>{`${formSchema?.venderRmsInfo?.venderAccStatusLabel} : `}</strong>

                <strong
                  style={{
                    color: getColor(formSchema?.venderRmsInfo?.venderStatusCode),
                  }}
                >
                  {formSchema?.venderRmsInfo?.venderAccStatus || '-ไม่ระบุ-'}
                </strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.taxLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.taxLabel} : `}
                <strong>{maskIdCard(formSchema?.venderRmsInfo?.taxId || '-ไม่ระบุ-')}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.venderCodeLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.venderCodeLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.venderCode || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.venderTypeLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.venderTypeLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.venderType || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.venderNameLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.venderNameLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.venderName || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          <Col xs={24} sm={24} md={24} lg={24}>
            <div style={{ marginBottom: 10, marginTop: 20, color: '#2da888' }}>
              <p>ที่อยู่/ติดต่อ</p>
            </div>
          </Col>

          {formSchema?.venderRmsInfo?.addressNumberLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.addressNumberLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.addressNumber || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.mooLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.mooLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.moo || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.soiLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.soiLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.soi || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.roadLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.roadLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.road || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.buildingLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.buildingLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.building || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.floorRoomLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.floorRoomLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.floorRoom || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.subDistrictLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.subDistrictLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.subDistrict || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.districtLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.districtLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.district || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.regionLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.regionLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.region || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.countryLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.countryLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.country || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.postalLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.postalLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.postal || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.emailLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.emailLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.email || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.faxLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.faxLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.fax || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.mobileLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.mobileLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.mobile || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}

          {formSchema?.venderRmsInfo?.telLabel && (
            <Col xs={24} sm={24} md={12} lg={12}>
              <p>
                {`${formSchema?.venderRmsInfo?.telLabel} : `}
                <strong>{formSchema?.venderRmsInfo?.tel || '-ไม่ระบุ-'}</strong>
              </p>
            </Col>
          )}
        </Row>
      </div>

      {formSchema?.rmsRequestFiles?.length > 0 ? (
        <div style={{ padding: 15 }}>
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <table border={1} width={'100%'}>
                <tr>
                  <th style={{ width: '10%' }}>
                    <p style={{ padding: 3 }}>ลำดับ</p>
                  </th>
                  <th style={{ width: '35%' }}>
                    <p style={{ padding: 3 }}>ประเภทของไฟล์แนบ</p>
                  </th>
                  <th style={{ width: '40%' }}>
                    <p style={{ padding: 3 }}>ไฟล์</p>
                  </th>
                  <th style={{ width: '15%' }}> #</th>
                </tr>
                {formSchema?.rmsRequestFiles.map((item, index) => {
                  return (
                    <tr>
                      <td align="center">
                        <p style={{ padding: 3 }}>{index + 1}</p>
                      </td>
                      <td>
                        <p style={{ padding: 3 }}>{item?.fileTypeDesc || ''}</p>
                      </td>
                      <td>
                        <p style={{ padding: 3, color: '#2da888' }}>{item?.fileName || ''}</p>
                        {/* {item?.fileName ? (
                          <>
                            <p style={{ padding: 3, color: '#2da888' }}>{item?.fileName || ''}</p>
                          </>
                        ) : (
                          <>
                            {item?.isRequired ? (
                              <p style={{ padding: 3, color: '#f2574a', fontWeight: 'bold' }}>
                                {'- ไม่พบไฟล์* -'}
                              </p>
                            ) : (
                              <p style={{ padding: 3, color: '#EEB189' }}>{'- ไม่พบไฟล์ -'}</p>
                            )}
                          </>
                        )} */}
                      </td>
                      <td align="center">
                        <div style={{ marginTop: 5 }}>
                          {item?.fileName && (
                            <PreviewButton
                              size="sm"
                              children="แสดง"
                              onClick={() => {
                                handlePreViewFiles(item)
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </table>
            </Col>
          </Row>
        </div>
      ) : (
        <>
          <div style={{ padding: 15 }}>
            <Message
              type="error"
              description={
                <b>ไม่พบไฟล์ในระบบที่ต้องทำการส่งไปยังระบบ RMS กรุณาติดต่อผู้ดูแลระบบ</b>
              }
            />
          </div>
        </>
      )}

      {formSchema?.button && (
        <div>
          <hr />
          {formSchema?.button?.refresh && (
            <>
              {/* {disableBindBtt && (
                <div style={{ padding: 5 }}>
                  <Message
                    type="error"
                    description={`ไม่พบ สำเนาบัญชีธนาคาร ไม่สามารถ${formSchema?.button?.refresh}`}
                  />
                </div>
              )} */}

              <ViewButton
                children={formSchema?.button?.refresh}
                icon="refresh2"
                // disabled={disableBindBtt}
                styleVal={{
                  marginRight: 10,
                  marginBottom: 10,
                }}
                onClick={() => {
                  handleRefresh()
                }}
              />
            </>
          )}

          {formSchema?.button?.create && (
            <>
              {/* {disableBindBtt && (
                <div style={{ padding: 5 }}>
                  <Message
                    type="error"
                    description={`ไม่พบ สำเนาบัญชีธนาคาร ไม่สามารถ${formSchema?.button?.create}`}
                  />
                </div>
              )} */}

              <SaveButton
                children={formSchema?.button?.create}
                // disabled={disableBindBtt}
                icon="user-plus"
                onClick={() => {
                  handleCreate()
                }}
              />
            </>
          )}

          {formSchema?.button?.bind && (
            <>
              {/* {disableBindBtt && (
                <div style={{ padding: 5 }}>
                  <Message
                    type="error"
                    description={`ไม่พบ สำเนาบัญชีธนาคาร ไม่สามารถ${formSchema?.button?.bind}`}
                  />
                </div>
              )} */}

              <SaveButton
                children={formSchema?.button?.bind}
                // disabled={disableBindBtt}
                icon="character-area"
                onClick={() => {
                  handleBind()
                }}
              />
            </>
          )}
        </div>
      )}
      <>
        {/* {disableBindBtt && (
                <div style={{ padding: 5 }}>
                  <Message
                    type="error"
                    description={`ไม่พบ สำเนาบัญชีธนาคาร ไม่สามารถ${formSchema?.button?.bind}`}
                  />
                </div>
              )} */}

        {/* <SaveButton
          children={formSchema?.button?.bind}
          // disabled={disableBindBtt}
          icon="character-area"
          onClick={() => {
            handleBind()
          }}
        /> */}
      </>
    </Panel>
  )
}
